module.exports = __webpack_public_path__ + "static/media/choithramsFaceCreamS.ec2f6489.png";